import {AsyncLegalNoticeScene, AsyncMissionStatementScene, AsyncNotFoundScene} from "../layouts/asyncScenes"
import {Page} from "./page/pages"

export const SIMPLE_ROUTES = [
    {
        page: Page.MISSION_STATEMENT,
        component: AsyncMissionStatementScene,
        pathKey: "routeWithParamDesc",
    },
    {page: Page.LEGAL_NOTICE, component: AsyncLegalNoticeScene},
]

export const NOT_FOUND_ROUTE = {page: null, component: AsyncNotFoundScene, pathOverride: "*", permissionRoutePath: ""}
